import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { LanguageLoader } from "../../assets/languages";
import { useRahkaranReportRunner } from "./RahkaranReportParamModal";

const Linkable = ({field, value, customization={}}) => {
	const language = LanguageLoader(useSelector((state) => state.preferences).language);
	const {module} = useParams();
	const { FetchRahkaranReport, paramModal } = useRahkaranReportRunner();

	if(module === 'Rahkaran_Reports' && field === 'execution')
	{
		return <>
			<span className='cursor-pointer hover:text-white bg-primary text-secondaryFont px-3 py-1 rounded' onClick={() => FetchRahkaranReport(value)}>{language.DOWNLOAD}</span>
			{paramModal}
		</>;
	}
	return null;
}

export default Linkable;
